import { Injectable } from '@angular/core';
import { Observable, Subject, timer, Subscription, merge, fromEvent } from 'rxjs';
import { EnvService } from '../../shared/environment-service/env.service';
@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private idle: Observable<any> = new Observable();
  private timer: Subscription = new Subscription();
  private timeOutMilliSeconds: number = 1000;
  private idleSubscription: Subscription = new Subscription();

  public expired: Subject<boolean> = new Subject<boolean>();

  constructor(public env: EnvService) {
      window.addEventListener('beforeunload', () => {
      this.stopTimer();
    });
  }

  public startWatching(): Observable<any> {
    let idleTimeInMinutes = this.env.IdleTimeInMinutes;
    const timeOutSeconds: number = idleTimeInMinutes * 60;
    this.idle = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'click'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'keypress'),
      fromEvent(document, 'DOMMouseScroll'),
      fromEvent(document, 'mousewheel'),
      fromEvent(document, 'touchmove'),
      fromEvent(document, 'MSPointerMove'),
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'resize'),
    );

    this.timeOutMilliSeconds = timeOutSeconds * 1000;

    this.idleSubscription = this.idle.subscribe((res) => {
      this.resetTimer();
    });

    this.startTimer();
    return this.expired;
  }

  private startTimer() {
    this.timer = timer(this.timeOutMilliSeconds, this.timeOutMilliSeconds).subscribe((res) => {
      this.expired.next(true);
    });
  }

  public resetTimer() {
    this.timer.unsubscribe();
    this.startTimer();
  }

  public stopTimer() {
    this.timer.unsubscribe();
    this.idleSubscription.unsubscribe();
  }
}
